import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Ticket, Image, Users, LogOut, Store, Settings } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/admin/coupons", icon: Ticket, label: "Coupons" },
  { to: "/admin/banners", icon: Image, label: "Banners" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/settings", icon: Settings, label: "Payment Settings" },
];

const AdminLayout = () => {
  const { user, loading, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-neutral-500">Loading...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: "/admin" }} replace />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex bg-[#f4f4f5]">
      {/* Sidebar */}
      <aside className="w-60 bg-[#050304] text-white flex flex-col fixed inset-y-0 left-0">
        <div className="px-6 py-5 border-b border-white/10">
          <img src="/logo.png" alt="Deegford" className="h-10 w-auto object-contain mb-1" />
          <p className="text-[10px] tracking-widest text-white/50 uppercase mt-1">Admin Panel</p>
        </div>
        <nav className="flex-1 py-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-gradient-to-r from-[#FFE29A]/20 to-[#C8932F]/20 text-[#FFE29A] border-r-2 border-[#FFE29A]"
                    : "text-white/70 hover:text-[#FFE29A] hover:bg-white/5"
                }`
              }
            >
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-4 space-y-2">
          <button onClick={() => navigate("/")} className="w-full flex items-center gap-3 px-2 py-2 text-sm text-white/70 hover:text-[#FFE29A]">
            <Store className="h-4 w-4" /> View Store
          </button>
          <button onClick={() => { logout(); navigate("/login"); }} className="w-full flex items-center gap-3 px-2 py-2 text-sm text-white/70 hover:text-[#FFE29A]">
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-60 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
